import * as yup from "yup";
import { add, endOfDay, format, startOfMonth } from "date-fns";
import { TFunction } from "i18next";

import { TIndicatorReportsConfigForm } from "~/components/Forms/IndicatorReportsConfigForm/index";
import { TypeGroupDealerIndicatorValues } from "~/schemas/generated/graphql";

export const formatReportDateBegin = (date: string) =>
  format(
    add(startOfMonth(new Date(date)), { days: 1 }),
    "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
  );

export const formatReportDateEnd = (date: string) =>
  format(endOfDay(new Date(date)), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

export const indicatorReportConfigFormSchema = (
  t: TFunction,
  groupTypeState: TypeGroupDealerIndicatorValues,
) => {
  switch (groupTypeState) {
    case TypeGroupDealerIndicatorValues.Regmen:
      return yup.object().shape({
        quarter: yup.object().shape({
          value: yup.string().nullable().required(t("validation.required")),
        }),
        year: yup.object().shape({
          value: yup.string().nullable().required(t("validation.required")),
        }),
      });
    default:
      return yup.object().shape({
        dateBegin: yup.string().nullable().required(t("validation.required")),
        dateEnd: yup.string().nullable().required(t("validation.required")),
      });
  }
};

export const indicatorReportConfigToParameters = (
  data: TIndicatorReportsConfigForm,
) => {
  const result = Object.keys(data).reduce((acc, key) => {
    if (typeof data[key] === "object") {
      if (Array.isArray(data[key])) {
        if (!data[key].length) return acc;
        return data[key]
          ? acc + `${key}=${data[key].map((el) => el.value).join(",")}&`
          : acc;
      } else {
        return data[key]?.value ? acc + `${key}=${data[key]?.value}&` : acc;
      }
    } else {
      if (key === "dateBegin" || key === "dateEnd")
        return key === "dateBegin"
          ? acc + `${key}=${formatReportDateBegin(data[key])}&`
          : acc + `${key}=${formatReportDateEnd(data[key])}&`;
      return data[key] ? acc + `${key}=${data[key]}&` : acc;
    }
  }, "?");

  return result === "?" ? "" : result;
};
